import { EventEmitter as EventEmitter3 } from 'eventemitter3';
export const EventEmitter = new EventEmitter3();
//# sourceMappingURL=event.emitter.js.map